import { Box, Portal, Stack } from '@mui/material';
import React, { ReactNode, useContext } from 'react';
import { QuoteFooterContext } from './QuoteEditorSurface';

export default function QuoteEditorTopBar({
  status,
  exit,
  save,
  headerActions
}: {
  status: ReactNode;
  exit: ReactNode;
  save: ReactNode;
  headerActions: ReactNode;
}) {
  const { setContainer } = useContext(QuoteFooterContext);
  return (
    <Stack
      data-testid="quote-editor-top-bar"
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="flex-end"
      alignItems={{ xs: 'stretch', md: 'center' }}
      spacing={1}
      sx={{ mx: { xs: 2, sm: 3, md: 6 }, mt: headerActions ? 2 : 0.5, mb: headerActions ? 1 : 0 }}
    >
      <Portal>
      <Stack
        data-testid="quote-editor-footer-bar"
        direction="row"
        alignItems="center"
        sx={{
          position: 'fixed', bottom: 0, left: 0, right: 0,
          boxSizing: 'border-box',
          zIndex: (theme) => theme.zIndex.appBar,
          px: { xs: 2, sm: 3, md: 6 }, py: 1.5,
          pb: 'max(12px, env(safe-area-inset-bottom))',
          backgroundColor: '#f1f3f5',
          borderTop: '1px solid #d9dfe6',
          boxShadow: '0 -3px 12px rgba(0,0,0,0.08)',
          flexWrap: 'wrap', gap: 1, '& > *': { flexShrink: 0 },
          '& button, & .MuiButton-root': {
            whiteSpace: 'nowrap', width: 'max-content', flexShrink: 0, height: 34, minHeight: 34
          }
        }}
      >
        {exit && <Box data-quote-top-action="exit">{exit}</Box>}
        {save && <Box data-quote-top-action="save">{save}</Box>}
        {status && <Box data-quote-top-action="status">{status}</Box>}
        <Box ref={setContainer} sx={{
          minWidth: 0, maxWidth: '100%', '&:empty': { display: 'none' },
          '&&': { flex: { xs: '0 1 100%', lg: '1 1 auto' }, width: { xs: '100%', lg: 'auto' } }
        }} />
      </Stack>
      </Portal>
      {headerActions && <Box data-quote-top-action="header" sx={{ width: '100%' }}>{headerActions}</Box>}
    </Stack>
  );
}
